import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import apiClient from "../lib/api";

const AuthCtx = createContext({ user: null, loading: true, login: async () => {}, register: async () => {}, logout: async () => {}, refresh: async () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await apiClient.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me check if returning from OAuth callback
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await apiClient.post("/auth/login", { email, password });
    localStorage.setItem("auth_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await apiClient.post("/auth/register", { email, password, name });
    localStorage.setItem("auth_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await apiClient.post("/auth/logout"); } catch {}
    localStorage.removeItem("auth_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: checkAuth }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
